import { render } from "./Home.vue?vue&type=template&id=0cf6105b&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=0cf6105b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0cf6105b"

export default script